import dayjs from 'dayjs'

export const formatDate = (input: string): string => dayjs(new Date(input)).format('DD.MM.YY')
